import { getPatternStyles, patternFns, __spreadValues } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const levelRightConfig = {
transform(props) {
  return __spreadValues({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gridArea: "right"
  }, props);
}}

export const getLevelRightStyle = (styles = {}) => {
  const _styles = getPatternStyles(levelRightConfig, styles)
  return levelRightConfig.transform(_styles, patternFns)
}

export const levelRight = (styles) => css(getLevelRightStyle(styles))
levelRight.raw = getLevelRightStyle